import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {
  View,
  Text,
  TouchableOpacity,
  Modal,
  StyleSheet,
  FlatList,
  Pressable,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';

const DropdownPicker = ({
  selectedValue,
  onValueChange,
  items,
  style,
  textStyle,
}) => {
  const [open, setOpen] = useState(false);

  const selectedItem =
    items.find((item) => item.value === selectedValue) || items[0];

  const handleSelect = (value) => {
    onValueChange(value);
    setOpen(false);
  };

  return (
    <View style={[styles.container, style]}>
      <TouchableOpacity
        style={styles.trigger}
        onPress={() => setOpen(true)}
        activeOpacity={0.7}>
        <Text style={[styles.triggerText, textStyle]} numberOfLines={1}>
          {selectedItem ? selectedItem.label : ''}
        </Text>
        <Icon name="menu-down" style={styles.caret} />
      </TouchableOpacity>

      <Modal
        transparent
        visible={open}
        animationType="fade"
        onRequestClose={() => setOpen(false)}>
        <Pressable style={styles.backdrop} onPress={() => setOpen(false)}>
          <Pressable style={styles.sheet} onPress={() => {}}>
            <FlatList
              data={items}
              keyExtractor={(item) => String(item.value)}
              renderItem={({item}) => {
                const isSelected = item.value === selectedValue;
                return (
                  <TouchableOpacity
                    style={[
                      styles.option,
                      isSelected && styles.optionSelected,
                    ]}
                    onPress={() => handleSelect(item.value)}
                    activeOpacity={0.7}>
                    <Text
                      style={[
                        styles.optionText,
                        isSelected && styles.optionTextSelected,
                      ]}>
                      {item.label}
                    </Text>
                    {isSelected ? (
                      <Icon name="check" style={styles.checkIcon} />
                    ) : null}
                  </TouchableOpacity>
                );
              }}
            />
          </Pressable>
        </Pressable>
      </Modal>
    </View>
  );
};

DropdownPicker.propTypes = {
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onValueChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }),
  ).isRequired,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  textStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

DropdownPicker.defaultProps = {
  selectedValue: undefined,
  style: undefined,
  textStyle: undefined,
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  trigger: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 44,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: '#CCC',
    borderRadius: 4,
    backgroundColor: '#FFF',
  },
  triggerText: {
    flex: 1,
    fontSize: 16,
    color: '#000',
  },
  caret: {
    fontSize: 24,
    color: '#666',
    marginLeft: 8,
  },
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 24,
  },
  sheet: {
    width: '100%',
    maxWidth: 320,
    maxHeight: '60%',
    backgroundColor: '#FFF',
    borderRadius: 8,
    paddingVertical: 8,
  },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 14,
    paddingHorizontal: 16,
  },
  optionSelected: {
    backgroundColor: '#F0F4FF',
  },
  optionText: {
    fontSize: 16,
    color: '#000',
  },
  optionTextSelected: {
    color: '#2196F3',
    fontWeight: '600',
  },
  checkIcon: {
    fontSize: 20,
    color: '#2196F3',
  },
});

export default DropdownPicker;
